import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AdminSidebar from "../shared/AdminSidebar";
import { getNodeApiBase } from "../../../utils/apiBase";
import "./Comite.css";

function Comite() {
  const [selectedItem, setSelectedItem] = useState("Comite");
  const [comites, setComites] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const apiBase = getNodeApiBase();
    fetch(`${apiBase}/api/comites`)
      .then((res) => res.json())
      .then((data) => {
        if (data.comites) setComites(data.comites);
      });
  }, []);

  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  const handleComiteClick = (comite) => {
    // Handle comite click
  };

  return (
    <div className="d-flex">
      <AdminSidebar />
      {selectedItem === "Comite" && (
        <div className="comite-main">
          <div className="table-container">
            <div className="comite-header">
              <h1 className="comite-title">COMITE</h1>
              <div className="comite-header__actions">
                <Link to={"/AjouterunComite"}>
                  <button className="btn btn-success mb-3">
                    + Ajouter un comite
                  </button>
                </Link>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="bg-primary text-white">
                  <tr>
                    <th scope="col">Competition</th>
                    <th scope="col">Titre</th>
                    <th scope="col">Date de Creation</th>
                    <th scope="col">Nombre d'expert</th>
                    <th scope="col" className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {comites.map((comite) => (
                    <tr
                      key={comite.id_comite}
                      onClick={() => handleComiteClick(comite)}
                    >
                      <td>{comite.competition_name}</td>
                      <td>{comite.titre_comite}</td>
                      <td>{comite.date_creation ? comite.date_creation.split("T")[0] : ""}</td>
                      <td>{comite.nombre_expert}</td>
                      <td className="text-center">
                        <button
                          style={{
                            backgroundColor: "#007bff",
                            color: "#fff",
                            marginRight: "5px",
                            border: "none",
                            borderRadius: "5px",
                            padding: "5px 10px",
                          }}
                          onClick={() => navigate(`/modifierComite/${comite.id_comite}`)}
                        >
                          Modifier
                        </button>
                        <button
                          style={{
                            backgroundColor: "#dc3545",
                            color: "#fff",
                            marginRight: "5px",
                            border: "none",
                            borderRadius: "5px",
                            padding: "5px 10px",
                          }}
                        >
                          Supprimer
                        </button>
                        <button
                          style={{
                            backgroundColor: "#28a745",
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            padding: "5px 10px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/AssignerComite/${comite.id_comite}`);
                          }}
                        >
                          Assigner
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Comite;
